import { createSlice } from '@reduxjs/toolkit';
// The editor representation of a schedule contain info at the same time for
// the different kinds of schedule. This so one for example can swap between
// time and sun settings and the editor remember the state of the input
// elements in each of them. When one id done and press save then
// we construct the data that is sent to the backed which includ
// include one of the representations.
export function isEditScheduleKind(v) {
    return v == 'cron' || v == 'sun' || v == 'time';
}
export const initialState = {
    id: null,
    kind: 'time',
    cron: '',
    sun: {
        k: 't',
        a: 0,
        w: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true },
        r: 'r0',
    },
    time: {
        h: 0,
        m: 0,
        w: { monday: true, tuesday: true, wednesday: true, thursday: true, friday: true, saturday: true, sunday: true },
    },
    active: true,
    transmitter_id: NaN,
    operation: 'on',
    dim_level: 15,
};
const slice = createSlice({
    name: 'edit_schedule_dialog',
    initialState,
    reducers: {
        setEditScheduleDialog(state, action) {
            state.id = action.payload.id;
            state.kind = action.payload.kind;
            state.cron = action.payload.cron;
            state.sun = action.payload.sun;
            state.time = action.payload.time;
            state.active = action.payload.active;
            state.transmitter_id = action.payload.transmitter_id;
            state.operation = action.payload.operation;
            state.dim_level = action.payload.dim_level;
        },
        setEditScheduleDialogKind(state, action) {
            state.kind = action.payload;
        },
        setEditScheduleDialogTime(state, action) {
            state.time.h = action.payload.h;
            state.time.m = action.payload.m;
        },
        setEditScheduleDialogWeekdays(state, action) {
            state.time.w = action.payload;
        },
        setEditScheduleDialogSunType(state, action) {
            state.sun.k = action.payload;
        },
        setEditScheduleDialogSunAjust(state, action) {
            state.sun.a = action.payload;
        },
        setEditScheduleDialogSunWeekdays(state, action) {
            state.sun.w = action.payload;
        },
        setEditScheduleDialogSunScheduleRandom(state, action) {
            state.sun.r = action.payload;
        },
        setEditScheduleDialogCron(state, action) {
            state.cron = action.payload;
        },
        setEditScheduleDialogTransmitter(state, action) {
            state.transmitter_id = action.payload;
        },
        setEditScheduleDialogActive(state, action) {
            state.active = action.payload;
        },
        setEditScheduleDialogOperation(state, action) {
            state.operation = action.payload;
        },
        setEditScheduleDialogDimLevel(state, action) {
            state.dim_level = action.payload;
        },
    }
});
export const { setEditScheduleDialog, setEditScheduleDialogKind, setEditScheduleDialogTime, setEditScheduleDialogWeekdays, setEditScheduleDialogSunType, setEditScheduleDialogSunAjust, setEditScheduleDialogSunWeekdays, setEditScheduleDialogSunScheduleRandom, setEditScheduleDialogCron, setEditScheduleDialogTransmitter, setEditScheduleDialogActive, setEditScheduleDialogOperation, setEditScheduleDialogDimLevel, } = slice.actions;
export const edit_schedule_dialog = slice.reducer;
